import { createAxiosQuery } from "@/hooks/react-query";
import { instance } from "@/lib/hooks";
import { GroupThermostatConfigProps } from "@/types";

export interface GroupThermostatSettingsOptions {
  groupId: number;
}
export interface GroupThermostatSettingsResponse {
  // A group may not have a saved thermostat config, so the row can be absent.
  data?: GroupThermostatConfigProps | null;
}

export const useGroupThermostatSettingsQuery = createAxiosQuery(
  "group-thermostat-settings",
  async (filters?: GroupThermostatSettingsOptions) =>
    instance.get<GroupThermostatSettingsResponse>(
      `/groups/${filters?.groupId}/thermostat-settings`
    )
);
